import { UseQueryResult } from '@tanstack/react-query'
import type { Except } from 'type-fest'
import { Loadable } from '../../../../../_shared/lib'

export type ValidatedQueryResult<T> = Except<UseQueryResult<T, Error>, 'refetch' | 'promise'>

export const validatedQueryResult = <T, TSource>(data: T | undefined, sourceQuery: UseQueryResult<TSource, Error>): ValidatedQueryResult<T> => {
  switch (sourceQuery.status) {
    case 'success': {
      if (data === undefined) {
        return errorValidatedQueryResult(new Error('data is undefined'), sourceQuery)
      }
      return {
        ...sourceQuery,
        data,
      }
    }
    case 'pending': {
      return sourceQuery
    }
    case 'error': {
      if (sourceQuery.isRefetchError) {
        if (data === undefined) {
          return errorValidatedQueryResult(new Error('data is undefined'), sourceQuery)
        }
        return {
          ...sourceQuery,
          data,
        }
      }
      return {
        ...sourceQuery,
        data: undefined,
      }
    }
  }
}
export const errorValidatedQueryResult = <T, TSource>(error: Error, sourceQuery: UseQueryResult<TSource, Error>): ValidatedQueryResult<T> => {
  return {
    ...sourceQuery,
    data: undefined,
    error,
    isError: true,
    isPending: false,
    isLoading: false,
    isLoadingError: true,
    isRefetchError: false,
    isSuccess: false,
    status: 'error',
  }
}

export const queryErrors = (queryResults: ValidatedQueryResult<unknown>[]): Error[] | undefined => {
  if (queryResults.every((queryResult) => queryResult.status !== 'error')) {
    return undefined
  }
  return queryResults.filter((queryResult) => queryResult.isError).map((queryResult) => queryResult.error)
}

export const convertQueryToLoadble = <T>(query: ValidatedQueryResult<T>): Loadable<T, string> => {
  if (query.status === 'success') {
    return {
      isLoading: false,
      value: query.data,
    }
  }
  if (query.status === 'error') {
    return {
      isLoading: false,
      error: query.error.message,
    }
  }
  return {
    isLoading: true,
  }
}
